import {useState, useEffect} from 'react';
import {Dimensions} from 'react-native';
import {debounce} from 'lodash';

/**
 * A hook that returns true if the device is currently wider than a specified
 * threshold.
 *
 * @param {number} [threshold=768] The width in pixels to use as the threshold.
 * If the device's width is greater than this, then the hook returns true.
 *
 * @returns {boolean} True if the device is wider than the given threshold.
 */
const useIsWideDevice = (threshold = 768) => {
  const [isWide, setIsWide] = useState(
    Dimensions.get('window').width > threshold,
  );
  useEffect(() => {
    const updateWidth = debounce(() => {
      const width = Dimensions.get('window').width;
      setIsWide(width > threshold);
    }, 100); // Debounce by 100ms
    const subscription = Dimensions.addEventListener('change', updateWidth);
    return () => {
      subscription.remove();
      updateWidth.cancel(); // Cancel the debounce on cleanup
    };
  }, [threshold]);
  return isWide;
};

export default useIsWideDevice;
